import React from "react"
import ReactDOM from "react-dom"
import "./index.scss"
import App from "./App"
import "../node_modules/font-awesome/css/font-awesome.min.css"
//import reportWebVitals from './reportWebVitals';

ReactDOM.render(<App />, document.getElementById("root"))

//<React.StrictMode>
//</React.StrictMode>

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
